import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Carousel as BsCarousel } from "bootstrap";
// import { Link } from "react-router-dom";
import img1 from "../assets/images/banner1.jpeg";
import img2 from "../assets/images/banner2.jpeg";
import img3 from "../assets/images/ry.jpg";
import img4 from "../assets/images/ryy.jpg";

function Banner() {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselImages = [img1, img2, img3, img4];

  useEffect(() => {
    const node = carouselRef.current;
    if (!node) {
      return undefined;
    }

    const carousel = new BsCarousel(node, {
      ride: "carousel",
      interval: 7000,
      pause: "hover",
      touch: true,
    });

    const handleSlide = (event) => {
      if (typeof event?.to === "number") {
        setActiveIndex(event.to);
      }
    };

    node.addEventListener("slid.bs.carousel", handleSlide);

    return () => {
      node.removeEventListener("slid.bs.carousel", handleSlide);
      carousel.dispose();
    };
  }, []);

  return (
    <>
      {/* Header Start */}
      <div className="container-fluid header hero-banner p-0">
        <div className="row g-0 align-items-center flex-column-reverse flex-lg-row mt-lg-5">
          <div className="col-lg-6 p-5 p-lg-5 hero-content">
            <span className="hero-badge hero-fade-up hero-delay-1">
              Trusted in Abuja and beyond
            </span>
            <h1 className="hero-title hero-fade-up hero-delay-2">
              Let Your <span className="text-primary">Family's Happiness </span>
              Begin in Your <span className="text-primary">Perfect Home</span>
            </h1>
            <p className="hero-lead hero-fade-up hero-delay-3">
              Embark on your family's journey to happiness by investing in a
              home that mirrors your dreams. Establish a steadfast foundation
              for both your family's joy and your investment aspirations with
              the ideal property.
            </p>
            <div className="hero-cta hero-fade-up hero-delay-4">
              <Link className="btn hero-btn hero-btn-primary" to="/properties">
                Explore properties
              </Link>
              <Link className="btn hero-btn hero-btn-ghost" to="/contact">
                Talk to an agent
              </Link>
            </div>
            <div className="hero-stats hero-fade-up hero-delay-5">
              <div className="hero-stat">
                <span className="hero-stat-value">50+</span>
                <span className="hero-stat-label">Verified listings</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">98%</span>
                <span className="hero-stat-label">Client satisfaction</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">24/7</span>
                <span className="hero-stat-label">Support team</span>
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 p-4 p-lg-5 hero-media hero-fade-up hero-delay-4"
            style={{ "--hero-bg-image": `url(${carouselImages[activeIndex]})` }}
          >
            <div
              id="carouselExampleSlidesOnly"
              className="carousel slide hero-carousel"
              ref={carouselRef}
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                />
                <button
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                />
                <button
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                />
                <button
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to="3"
                  aria-label="Slide 4"
                />
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img
                    src={img1}
                    className="d-block w-100 hero-slide-image"
                    alt="Modern home exterior"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src={img2}
                    className="d-block w-100 hero-slide-image"
                    alt="Luxury living space"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src={img3}
                    className="d-block w-100 hero-slide-image"
                    alt="Elegant property frontage"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src={img4}
                    className="d-block w-100 hero-slide-image"
                    alt="Premium neighborhood view"
                  />
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleSlidesOnly"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleSlidesOnly"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
      {/* Header End */}
    </>
  );
}

export default Banner;
